import React, { useState } from "react";
import { HashRouter } from "react-router-dom"; // ✅ Add this import
import Login from "./Login/Login";
import Home from "./Modules/Home";

function App() {
  const [LoginStatus, setLoginStatus] = useState(() => {
    const saved = localStorage.getItem("login");
    if (saved) {
      const parsed = JSON.parse(saved);
      return parsed.login || "";
    }
    return "";
  });

  return (
    !LoginStatus ? (
      <Login />
    ) : (
      <HashRouter>
        <Home />
      </HashRouter>
    )
  );
}

export default App;
